module.exports = __webpack_public_path__ + "img/25cc03b.jpg";